/* ---------------------------------------------------------------------
   Robert Kee — Bundler: auto-add the FIRST product to the chosen items
   ---------------------------------------------------------------------
   This file is PURE JavaScript (no <script> tags) so it is valid as a
   theme asset.

   HOW TO ADD (pick ONE):

   A) As a theme asset (recommended):
      1. Online Store > Themes > Edit code > Assets > Add a new asset,
         upload this file (bundler-auto-add-first.js).
      2. In layout/theme.liquid, just before </body>, add:
         <script src="{{ 'bundler-auto-add-first.js' | asset_url }}" defer></script>

   B) Inline: paste the code below INSIDE a <script> ... </script> block
      in theme.liquid (before </body>) or a custom HTML/Liquid block on
      the bundle product template.

   It waits for the Bundler widget to render, adds the first available
   product, and keeps it added even if the app re-renders. Once the
   selection has been stable for ~2s it stops, so a customer can still
   remove the item afterwards if they want.
--------------------------------------------------------------------- */
(function () {
  "use strict";

  var settled = false;     // stop auto-adding once first selection is stable
  var stableSince = 0;
  var ticks = 0;
  var MAX_TICKS = 80;      // ~40s safety window for the initial poll

  // Product URLs currently in the chosen/summary area (stable across the
  // app's re-renders, unlike DOM node references).
  function chosenHrefs() {
    var nodes = document.querySelectorAll(
      ".bndlr-sectioned-section-products .bndlr-sectioned-status-box-product a[href*='/products/']"
    );
    return Array.prototype.map.call(nodes, function (a) {
      return (a.getAttribute("href") || "").split("?")[0];
    });
  }

  function cardHref(card) {
    var a = card.querySelector(
      "a.bndlr-product-title, a.bndlr-product-image-url, a[href*='/products/']"
    );
    return a ? (a.getAttribute("href") || "").split("?")[0] : null;
  }

  // Hide any option whose product is already in the bundle; show the rest.
  // Re-runs on every render so the hidden item stays hidden, and reappears
  // automatically if the customer removes it.
  //
  // NOTE: the card has `display: grid !important` from the CSS, so a plain
  // inline `style.display = "none"` is overridden by that !important rule and
  // the card stays visible. We MUST set the hide with priority "important"
  // (and clear it with removeProperty) so it actually wins.
  function syncHidden() {
    var chosen = chosenHrefs();
    var cards = document.querySelectorAll(
      ".bndlr-sectioned-available-products .bndlr-sectioned-product"
    );
    for (var i = 0; i < cards.length; i++) {
      var h = cardHref(cards[i]);
      if (h && chosen.indexOf(h) > -1) {
        cards[i].style.setProperty("display", "none", "important");
      } else {
        cards[i].style.removeProperty("display");
      }
    }
  }

  function hasSelection() { return chosenHrefs().length > 0; }

  // First option that isn't already hidden/chosen.
  function firstVisibleCard() {
    var list = document.querySelector(".bndlr-sectioned-available-products");
    if (!list) return null;
    var cards = list.querySelectorAll(".bndlr-sectioned-product");
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].style.display !== "none") return cards[i];
    }
    return null;
  }

  function addFirst() {
    var card = firstVisibleCard();
    if (!card) return;
    var btn = card.querySelector(".bndlr-add-to-sectioned-bundle");
    if (btn) btn.click();
  }

  function tick() {
    if (!settled) {
      if (hasSelection()) {
        if (!stableSince) stableSince = Date.now();
        // selection has stuck for 2s -> stop auto-adding; customer in control
        if (Date.now() - stableSince > 2000) settled = true;
      } else {
        stableSince = 0;
        addFirst();          // (re)add until the first selection sticks
      }
    }
    syncHidden();            // keep chosen items hidden from the option list
  }

  var interval = setInterval(function () {
    tick();
    if (++ticks > MAX_TICKS) clearInterval(interval);
  }, 500);

  // React instantly to the app injecting / re-rendering the widget, and keep
  // the hide-sync running for the life of the page.
  try {
    new MutationObserver(tick).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  } catch (e) {}
})();